/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes';

/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions
     */
    PlayUrl?: string | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions
     */
    Runtimes?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes | null;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions {
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'PlayUrl': json['PlayUrl'] == null ? undefined : json['PlayUrl'],
        'Runtimes': json['Runtimes'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSON(json['Runtimes']),
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PlayUrl': value['PlayUrl'],
        'Runtimes': FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSON(value['Runtimes']),
    };
}

